import React, { useState } from 'react';
import { debounce } from 'lodash';
import { Typography, Stack, Button, InputAdornment, useTheme, Box, TextField, IconButton, Menu, MenuItem, Tooltip, Checkbox, FormControlLabel } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FilterActions from './SplitActions/FIlterAction';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useCallback } from 'react';
import FilterButtons from './DataTable/FilterButtons';
import { useEffect } from 'react';
import ArchiveIcon from '@mui/icons-material/Archive';
import { CancelToken } from 'apisauce';
import appapi from '../api/apiClient';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const DownloadButton = ({ onSelect }) => {
  const { t } = useTranslation()
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (type) => {
    setAnchorEl(null);
    if (onSelect) {
      onSelect(type);
    }
  };

  return (
    <div>
      <Tooltip
        title={t('Export Data')}
        placement="top"
      >
        <IconButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          style={{ flexDirection: 'row' }}
          sx={{
            color: theme.palette.grey.main,
            borderRadius: '4px',
            // '&:hover': {
            //   color: theme.palette.primary.text,
            // },
          }}
        >
          <SaveAltIcon />
          <ExpandMoreIcon style={{ width: '18px', height: '14px' }} />
        </IconButton>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          className="!text-[14px]"
          sx={{ color: '#313131' }}
          onClick={() => handleSelect('excel')}
        >
          EXCEL
        </MenuItem>
        <MenuItem
          className="!text-[14px]"
          sx={{ color: '#313131' }}
          onClick={() => handleSelect('csv')}
        >
          CSV
        </MenuItem>
      </Menu>
    </div>
  );
};

const RefreshButton = ({ onRefresh }) => {
  const { t } = useTranslation()
  const theme = useTheme();
  return (
    <div>
      <Tooltip
        title={t('Refresh')}
        placement="top"
      >
        <IconButton
          onClick={() => onRefresh()}
          sx={{
            color: theme.palette.grey.main,
            borderRadius: '4px',
            '&:hover': {
              color: theme.palette.primary.text,
            },
          }}
        >
          <RefreshIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

const ArchiveButton = ({ onArchive, disableArchive, isArchive }) => {
  const { t } = useTranslation()
  const theme = useTheme();
  return (
    <div>
      <Tooltip
        title={isArchive ? t('Restore') : t('Archive')}
        placement="top"
      >
        <IconButton
          disabled={disableArchive}
          onClick={() => onArchive()}
          sx={{
            color: theme.palette.grey.main,
            borderRadius: '4px',
            '&:hover': {
              color: theme.palette.primary.text,
            },
          }}
        >
          <ArchiveIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

const ColumnPreference = ({ columns = [], maxSelection = 7, applyColumnPreference }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [checkList, setCheckList] = React.useState([]);
  const [activeColumns, setActiveColumns] = React.useState(0);

  const { t } = useTranslation()

  useEffect(() => {
    setCheckList([...columns]);
  }, [columns]);

  useEffect(() => {
    setActiveColumns(columns.filter((res) => res.activeColumn).length);
  }, [checkList]);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event) => {
    const temp = [...checkList];
    temp[event.target.value].activeColumn = event.target.checked;
    setCheckList(temp);
  };

  const apply = () => {
    if (applyColumnPreference) {
      applyColumnPreference(checkList);
    }
    setAnchorEl(null);
  };

  const reset = () => {
    if (applyColumnPreference) {
      const temp = [...columns];
      applyColumnPreference(
        temp.map((res) => {
          return {
            ...res,
            activeColumn: res.default,
          };
        }),
      );
    }
    setAnchorEl(null);
  };

  return (
    <div>
      {/* <Tooltip title="Export Data" placement="top"> */}
      <IconButton
        id="cp-button"
        aria-controls={open ? 'cp-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        style={{ flexDirection: 'row' }}
        sx={{
          color: theme.palette.grey.main,
          '&:hover': {
            color: theme.palette.primary.text,
          },
        }}
      >
        <ViewColumnIcon />
      </IconButton>
      {/* </Tooltip> */}
      <Menu
        id="cp-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'cp-button',
        }}
      >
        <Typography
          color={'#14285A'}
          className="!text-[12px] !ml-[16px] !my-[16px] fw-medium"
        >
         {t('Columns')}
        </Typography>
        {checkList?.map(
          (checkbox, index) =>
            index != 0 && (
              <MenuItem
                disabled={!checkbox.columnEditable || (activeColumns === maxSelection && !checkbox?.activeColumn)}
                key={checkbox.accessor}
              >
                <FormControlLabel
                  disabled={!checkbox.columnEditable}
                  labelPlacement="end"
                  control={
                    <Checkbox
                      sx={{
                        p: 0,
                        pr: '16px',
                        pl: '11px',
                        '& .MuiSvgIcon-root': {
                          height: 18,
                          width: 18,
                        },
                      }}
                      onChange={handleChange}
                      value={checkbox?.id}
                      checked={checkbox?.activeColumn}
                      name={checkbox.header}
                      id={checkbox.accessor}
                      color={'primary'}
                    />
                  }
                  label={
                    <Typography
                      color={theme.palette.primary.text}
                      className="!text-[14px]"
                    >
                      {t(checkbox?.header) || '-'}
                    </Typography>
                  }
                />
              </MenuItem>
            ),
        )}
        {
          <Stack
            style={{ borderTop: 'solid 0.01px #cecccc', background: theme.palette.background.main }}
            direction="row"
            spacing={1}
            className="!px-[6px] !pt-[8px] !justify-around !sticky !bottom-[0]"
          >
            <FilterButtons
              onClick={() => reset()}
              name={`Reset`}
            />
            <FilterButtons
              onClick={() => apply()}
              name={`Apply`}
            />
          </Stack>
        }
      </Menu>
    </div>
  );
};

export default function PageHeader({ children, handleFilterButton, showSearchBar = true, handleOnSearchEmit, searchValue = null, useSearchValue, tableType, headerColor, handleClose, showCloseBtn = false, showExport = false, onExport, columns = [], columnPreference = false, maxSelection = 7, applyColumnPreference, showBackBtn = false, OnBackBtn, onRefresh, showArchive, onArchive, disableArchive, isArchive }) {
  const theme = useTheme();
  const [search, setSearch] = useState('');
  const [filterOpen, setFilterOpen] = useState(false);




  const request = debounce((tempValue) => {
    handleOnSearchEmit(tempValue ? tempValue : null);
  }, 400);

  const debouceRequest = useCallback((value) => request(value), []);

  const handleOnChange = (event) => {
    setSearch(event.target.value.trimStart());
    debouceRequest(event.target.value.trimStart());
  };

  const handleFilters = () => {
    setFilterOpen(!filterOpen);
  };

  useEffect(() => {
    if (useSearchValue) {
      setSearch(searchValue);
    }
  }, [searchValue]);



  return (
    <>
      <Box
        className="flex justify-start items-center h-[56px] p-[5px] bg-[#FFF] rounded-t-lg"
        sx={{ backgroundColor: headerColor, marginLeft: tableType === '2' ? '0px' : '0px', marginTop: 0 }}
      >
        {tableType === '2' ? (
          <>
            <Stack
              className=""
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
              flex={1}
            >
              <Stack flex={1}>{children}</Stack>
              <Stack
                direction={'row'}
                className="ml-[10px]"
              >
                {showSearchBar && <TextField
                  type='text'
                  className={!showCloseBtn ? '!mr-[16px]' : ''}
                  placeholder={null}
                  id="sdx"
                  name="sdx"
                  value={search || ''}
                  onChange={handleOnChange}
                  size="small"
                  sx={{
                    maxWidth: '250px',
                    minWidth: '250px',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1,
                      '& input::placeholder': {
                        fontSize: '10px',
                      },
                    },
                  }}
                  InputProps={{
                    autoComplete: 'new-password',
                    endAdornment: (
                      <InputAdornment
                        disablePointerEvents
                        position="end"
                      >
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />}
                {showCloseBtn && (
                  <IconButton
                    sx={{
                      ml: 0,
                    }}
                  >
                    <ClearIcon
                      style={{ transform: 'scale(1)', color: 'rgba(255, 255, 255,0.5)' }}
                      onClick={() => {
                        handleClose();
                      }}
                    />
                  </IconButton>
                )}
              </Stack>
            </Stack>
          </>
        ) : (
          <Stack
            direction={'row'}
            alignItems={'center'}
            flex={1}
          >
            {/* {handleFilterButton ? (
              <IconButton
                className="ml-[10px]"
                sx={{
                  color: theme.palette.grey.main,
                  '&:hover': {
                    color: theme.palette.primary.text,
                  },
                }}
                onClick={() => {
                  handleFilters();
                }}
              >
                <FilterListIcon />
              </IconButton>
            ) : (
              <IconButton
                className="ml-[10px]"
                sx={{
                  color: theme.palette.grey.main,
                  '&:hover': {
                    color: theme.palette.primary.text,
                  },
                }}
                onClick={() => {
                  handleFilters();
                }}
              >
                <ArrowBackIcon />
              </IconButton>
            )} */}
            {showBackBtn && (
              <IconButton
                className="ml-[10px]"
                sx={{
                  color: theme.palette.primary.text,
                  '&:hover': {
                    color: theme.palette.primary.text,
                  },
                }}
                onClick={() => {
                  OnBackBtn();
                }}
              >
                <ArrowBackIcon />
              </IconButton>
            )}
            <Stack
              alignItems={'center'}
              direction="row"
              className="ml-[10px]"
            >
              {showSearchBar && <TextField
                type='text'
                className="!mr-[16px]"
                placeholder={null}
                id="sdx"
                name="sdx"
                value={search || ''}
                onChange={handleOnChange}
                size="small"
                sx={{
                  maxWidth: '250px',
                  minWidth: '250px',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1,
                    '& input::placeholder': {
                      fontSize: '10px',
                    },
                  },
                }}
                InputProps={{
                  autoComplete: 'new-password',
                  endAdornment: (
                    <InputAdornment
                      disablePointerEvents
                      position="end"
                    >
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />}
              {columnPreference && (
                <ColumnPreference
                  columns={columns}
                  maxSelection={maxSelection}
                  applyColumnPreference={applyColumnPreference}
                />
              )}
              {columnPreference && (
                <Stack
                  sx={{ backgroundColor: 'rgba(20, 40, 90,0.1)' }}
                  className="h-[24px] w-[1px] mx-[8px]"
                />
              )}
              {showExport && <DownloadButton onSelect={onExport} />}
              {showExport && Boolean(onRefresh) && (
                <Stack
                  sx={{ backgroundColor: 'rgba(20, 40, 90,0.1)' }}
                  className="h-[24px] w-[1px] mx-[8px]"
                />
              )}
              {showArchive && (
                <ArchiveButton
                  onArchive={onArchive}
                  disableArchive={disableArchive}
                  isArchive={isArchive}
                />
              )}
              {showArchive && Boolean(onRefresh) && (
                <Stack
                  sx={{ backgroundColor: 'rgba(20, 40, 90,0.1)' }}
                  className="h-[24px] w-[1px] mx-[8px]"
                />
              )}
              {(Boolean(onRefresh) || showArchive) && <RefreshButton onRefresh={onRefresh} />}
            </Stack>
            <Stack flexGrow={1}>{children}</Stack>
            {/* <FilterActions
              open={filterOpen}
              handleFilter={() => {
                handleFilters();
              }}
            /> */}
          </Stack>
        )}
      </Box>
    </>
  );
}
